import mhiSettings from "./mhi";
import pdvendSettings from "./pdvend";

const faviconAndTitleSetting = {
  MHI: mhiSettings,
  PDVEND: pdvendSettings
};

const settings = faviconAndTitleSetting[process.env.REACT_APP_WHITELABEL_NAME];

export default settings;



// WEBPACK FOOTER //
// ./src/assets/head/index.js